import type { I18nT } from '@runtime/core/i18n/i18n'
import type { SupportedLocale } from '@runtime/core/i18n/i18n'
import { CoachRequestError } from './coachClient'

export function coachErrorMessage(
  error: unknown,
  t: I18nT,
  locale: SupportedLocale = 'fr',
): string {
  if (!(error instanceof CoachRequestError)) return t('coach.unavailable')
  if (error.code === 'timeout') return t('coach.unavailableTimeout')
  if (error.code === 'rate_limited') {
    return error.retryAfterSeconds
      ? t('coach.unavailableRateLimitedWithDelay', {
          seconds: error.retryAfterSeconds,
        })
      : t('coach.unavailableRateLimited')
  }
  const resetsAt = formatReset(error.resetsAt, locale)
  if (error.quotaScope === 'anonymous') {
    return resetsAt ? t('coach.quota.anonymousWithReset', { resetsAt }) : t('coach.quota.anonymous')
  }
  if (error.quotaScope === 'network') {
    return resetsAt ? t('coach.quota.networkWithReset', { resetsAt }) : t('coach.quota.network')
  }
  if (error.quotaScope === 'account') {
    return resetsAt ? t('coach.quota.accountWithReset', { resetsAt }) : t('coach.quota.account')
  }
  if (error.quotaScope === 'global') {
    return resetsAt ? t('coach.quota.globalWithReset', { resetsAt }) : t('coach.quota.global')
  }
  if (error.code === 'quota_exceeded') return t('coach.unavailableQuota')
  return t('coach.unavailable')
}

function formatReset(value: string | undefined, locale: SupportedLocale): string | undefined {
  if (!value) return undefined
  const date = new Date(value)
  if (!Number.isFinite(date.getTime())) return undefined
  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(date)
}
